import { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import App from "App";
import "locale";
import reportWebVitals from "reportWebVitals";
import store from "store/reducer";
import ProtectedRoute from "components/protected-route";
import PublicRoute from "components/public-route";
import ErrorBoundary from "components/error-boundary";
import { lazyWithRetry } from "utils/lazy-with-retry";
import { AlertProvider } from "utils/alerts";
import AnalyticsTracker from "components/analytics-tracker";
import routes from "./routes";
import ReactGA from "react-ga";

// Component Imports
const Loading = lazyWithRetry(() => import("./components/loading"));

// Initialize Google Analytics
const TRACKING_ID = process.env.REACT_APP_GTM_ID || "UA-000000-01"; // Fallback ID to prevent errors if env is missing
ReactGA.initialize(TRACKING_ID);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <Suspense fallback={<Loading />}>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Provider store={store}>
          <AnalyticsTracker />
          <AlertProvider>
            <App>
              <Routes>
                {renderRoutes(routes.blankLayout, "blank")}
                {renderRoutes(routes.defaultLayout, "default")}
              </Routes>
            </App>
          </AlertProvider>
        </Provider>
      </Router>
    </Suspense>
  </ErrorBoundary>
);

// Generic renderer for any route list
function renderRoutes(routesArray = [], prefix = "route") {
  return routesArray.map(
    ({ path, element: Element, layout, isProtected }, index) => (
      <Route
        key={`${prefix}-${index}`}
        path={path}
        element={
          isProtected ? (
            <ProtectedRoute layout={layout}>
              <Element />
            </ProtectedRoute>
          ) : (
            <PublicRoute layout={layout}>
              <Element />
            </PublicRoute>
          )
        }
      />
    )
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
